var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.989,
    height: 23.6,
    viewBox: "0 0 25.989 23.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.849,
    x2: 0.5,
    y2: 1.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07ebfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49b1fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.499,
    y1: 0.012,
    x2: 0.499,
    y2: 0.965,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt_logout",
    transform: "translate(0 -1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9953",
    "data-name": "Path 9953",
    d: "M25.6,11.9,22.8,9.1a1.485,1.485,0,0,0-2.1,2.1l.2.2H12.8a1.5,1.5,0,0,0,0,3h8.1l-.2.2a1.45,1.45,0,0,0,0,2.1,1.713,1.713,0,0,0,2.2,0l2.8-2.8A1.66,1.66,0,0,0,25.6,11.9Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9954",
    "data-name": "Path 9954",
    d: "M11.8,24.8a11.8,11.8,0,1,1,0-23.6,11.565,11.565,0,0,1,8.8,4,1.487,1.487,0,0,1-2.2,2,8.794,8.794,0,1,0-6.6,14.6A8.628,8.628,0,0,0,18.2,19a1.487,1.487,0,1,1,2.2,2A11.823,11.823,0,0,1,11.8,24.8Z",
    fill: "url(#linear-gradient-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.990f12a19ec61ab90533199f93705454.svg";
export { ForwardRef as ReactComponent };